import saveAs from "file-saver";

const DownloadFile = (blobPart: BlobPart, fileNAme: string) => {    
    const blobUrl = window.URL.createObjectURL(new Blob([blobPart]));
    saveAs(blobUrl, fileNAme);
}

export default DownloadFile;